import { Component, EventEmitter, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { PrescriptionFulfillmentTypeEnum } from 'src/app/enums/prescription-fulfillment-type-enum';
import { RequestStatusTypeEnum } from 'src/app/enums/request-status-type-enum';
import { showNotification } from 'src/app/helpers/show-toast';
import { PrescriptionService } from 'src/app/_services/prescription-fulfillment/prescription.service';
import { PrescriptionRequestStatusEnum } from './../../../enums/prescription-request-status-enum';

@Component({
  selector: 'app-medication-request-status-modal',
  templateUrl: './medication-request-status-modal.component.html',
  styleUrls: ['./medication-request-status-modal.component.scss'],
})
export class MedicationRequestStatusModalComponent implements OnInit {
  requestId;
  requestStatus: number;
  prescriptionRequestStatusEnum = PrescriptionRequestStatusEnum;
  isInProgress: boolean = false;
  prescriptionTypeId: number;
  prescriptionFulfillmentTypeEnum = PrescriptionFulfillmentTypeEnum;
  public event: EventEmitter<any> = new EventEmitter();

  constructor(
    public bsModalRef: BsModalRef,
    private toastr: ToastrService,
    private prescriptionService: PrescriptionService
  ) {}

  ngOnInit(): void {
    this.isInProgress =
      this.requestStatus == this.prescriptionRequestStatusEnum.InProgress
        ? true
        : false;

    this.requestStatus = this.isInProgress
      ? this.prescriptionRequestStatusEnum.Finished
      : this.prescriptionRequestStatusEnum.InProgress;
  }

  onStatusChange(value) {
    this.requestStatus = value;
  }

  onMedicationRequestStatusSubmit() {
    this.prescriptionService
      .updateRequestStatus(
        +this.requestId,
        this.requestStatus,
        RequestStatusTypeEnum.Medication
      )
      .subscribe((response) => {
        if (response?.data) {
          this.event.emit({
            requestStatus: this.requestStatus,
            data: response.data
          });
          showNotification(
            'success',
            'The request status has been updated successfully.',
            this.toastr
          );
        }
      });

    this.bsModalRef.hide();
  }
}
